export default "__VITE_ASSET__Cos4kY2g__"